import React from "react";
import styled from "styled-components";
import { color, font } from "../../theme/tokens";
import Portrait from "../layout/Portrait";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 28px;

  @media (max-width: 1000px) { grid-template-columns: repeat(4, 1fr); }
  @media (max-width: 760px)  { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 520px)  { grid-template-columns: repeat(2, 1fr); gap: 20px; }
`;

const Person = styled.div``;

const StyledPortrait = styled(Portrait)`
  img {
    filter: grayscale(1);
    transition: filter 260ms ease, transform 400ms ease;
  }

  ${Person}:hover & img {
    filter: grayscale(0);
    transform: scale(1.03);
  }
`;

const Name = styled.div`
  font-family: ${font.display};
  font-size: 16px;
  font-weight: 500;
  color: ${color.inkStrong};
  margin-top: 14px;
  line-height: 1.3;
`;

const Company = styled.div`
  font-family: ${font.body};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${color.inkMuted};
  margin-top: 5px;
`;

export default function FoundersGrid({ founders = [] }) {
  return (
    <Grid>
      {founders.map((f, i) => (
        <Person key={i}>
          <StyledPortrait src={f.image} name={f.name} />
          <Name>{f.name}</Name>
          <Company>{f.company}</Company>
        </Person>
      ))}
    </Grid>
  );
}
